import './index.css';
import { useContext, useId, useRef, useEffect } from 'react';
import { SnackbarContext } from './context.js';
import { SnackbarTransitionName } from './types.js';

const Snackbar = ({ removeOnUnmount = true, ...rest }) => {
    const context = useContext(SnackbarContext);
    const uid = useId();
    const removeOnUnmountRef = useRef(removeOnUnmount);
    removeOnUnmountRef.current = removeOnUnmount;
    useEffect(() => {
        context.animateIn(uid, rest);
    }, [context, uid, rest]);
    useEffect(() => {
        return () => {
            if (!removeOnUnmountRef.current) {
                return;
            }
            context.animateOut(uid, context.isShown(uid) ? SnackbarTransitionName.Hide : SnackbarTransitionName.RemoveImmediately);
        };
    }, [context, uid]);
    return null;
};

export { Snackbar };
//# sourceMappingURL=Snackbar.js.map
